import { DateTime } from 'luxon';

import CalendarPicker from '../Elements/CalendarPicker';
import { TabButton } from '../Elements/TabButton';
import { TimePicker } from '../Elements/TimePicker';

import Styles from './index.module.scss';

import type { FilterTimeType } from 'types/Filter';

import { convertToTimeFromPeriod } from '@/app/utils/period';

type Value = {
	startTime: string;
	endTime: string;
	timeType: FilterTimeType;
};

interface Props {
	value?: Value;
	onChange?: (item: Value) => void;
}

export const PeriodSelector = ({ value, onChange }: Props) => {
	const types: FilterTimeType[] = ['daily', 'weekly', 'monthly', 'custom'];

	return (
		<div className={Styles.container}>
			{types.map((item) => {
				return (
					<TabButton
						key={item}
						isSelected={value?.timeType === item}
						onClick={() => {
							onChange?.({
								timeType: item,
								...convertToTimeFromPeriod(item),
							});
						}}
					>
						{item}
					</TabButton>
				);
			})}

			<TimePicker value={value} onChange={onChange} />
			{value?.timeType === 'custom' && (
				<CalendarPicker
					selectionMode={'custom'}
					value={{
						start: value?.startTime
							? DateTime.fromISO(value.startTime)
							: DateTime.now().startOf('day'),
						end: value?.endTime
							? DateTime.fromISO(value.endTime)
							: DateTime.now().endOf('day'),
					}}
					onChange={(e) => {
						onChange?.({
							timeType: value?.timeType ?? 'daily',
							startTime: e.start.toISO() ?? DateTime.now().startOf('day').toISO(),
							endTime: e.end.toISO() ?? DateTime.now().endOf('day').toISO(),
						});
					}}
				/>
			)}
		</div>
	);
};
